// File generated by MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
import { OrderFiltersDto, OrderFiltersDtoFormGroup } from './OrderFiltersDto';

export class PaymentOrderFiltersDto extends OrderFiltersDto {
}

export interface PaymentOrderFiltersDtoFormGroup extends OrderFiltersDtoFormGroup {
}
